import { render, staticRenderFns } from "./AddDisability.vue?vue&type=template&id=4e3e4348&scoped=true"
import script from "./AddDisability.vue?vue&type=script&lang=js"
export * from "./AddDisability.vue?vue&type=script&lang=js"
import style0 from "./AddDisability.vue?vue&type=style&index=0&id=4e3e4348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e4348",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
